import React from "react";
import { Link } from "react-router-dom";
import BoxedTitle from "@/components/BoxedTitle";

const BOX_IMG =
  "https://static.prod-images.emergentagent.com/jobs/063b9062-b1d7-4f16-8d31-e465e039ed51/images/406df7120a6f61d5a26734ee207025f1cc4c38f0ee6cb74ba0fb777e8ec5e47f.png";

const projects = [
  {
    slug: "allamericandog",
    name: "All American Dog Club",
    status: "In Development",
    year: "2025–",
    description:
      "A community and platform celebrating the American dog. Built end-to-end inside VBB using AI-accelerated product workflows.",
    href: "https://allamericandog.club",
    image:
      "https://images.unsplash.com/photo-1504430225224-21a649ac91bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwZG9nJTIwZ29sZGVuJTIwcmV0cmlldmVyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc5MzIxNjEyfDA&ixlib=rb-4.1.0&q=85",
    tags: ["Product", "Community", "AI-assisted"],
  },
];

export default function Portfolio() {
  return (
    <main data-testid="portfolio-page">
      <section className="mx-auto max-w-[1400px] px-6 lg:px-10 pt-20 lg:pt-28 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="vbb-overline">
              <span className="vbb-dot" />
              Portfolio
            </div>
            <h1
              className="font-display uppercase text-5xl sm:text-7xl lg:text-[8rem] leading-[0.92] tracking-tighter mt-6 pl-[0.35em]"
              data-testid="portfolio-title"
            >
              <BoxedTitle size="lg" thick>
                Work,
              </BoxedTitle>
              <br />
              in progress.
            </h1>
            <p className="mt-8 max-w-2xl text-[17px] leading-relaxed text-[#2a2a2a]">
              VBB takes on a small number of projects at a time — either
              incubated in-house or co-built with founders. Selected work
              below.
            </p>
          </div>
          <div
            className="lg:col-span-5 aspect-[4/5] border border-[#0a0a0a] overflow-hidden vbb-grain"
            data-testid="portfolio-hero-image"
          >
            <img
              src={BOX_IMG}
              alt="Floating boxes"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      <section
        className="vbb-border-t"
        data-testid="portfolio-grid"
      >
        <div className="mx-auto max-w-[1400px]">
          {projects.map((p, idx) => (
            <article
              key={p.slug}
              className={`grid grid-cols-1 lg:grid-cols-12 ${
                idx > 0 ? "vbb-border-t" : ""
              } vbb-portfolio`}
              data-testid={`portfolio-item-${p.slug}`}
            >
              <div className="lg:col-span-7 border-[#0a0a0a] lg:vbb-border-r overflow-hidden">
                <div className="aspect-[16/10]">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-cover vbb-portfolio-img"
                  />
                </div>
              </div>
              <div className="lg:col-span-5 p-10 lg:p-14 flex flex-col justify-between">
                <div>
                  <div className="flex items-center justify-between">
                    <div className="font-mono-tiny text-[#6b6b6b]">
                      {p.year}
                    </div>
                    <div className="font-mono-tiny text-[#e34234]">
                      {p.status}
                    </div>
                  </div>
                  <h2 className="font-display text-4xl sm:text-5xl mt-6 uppercase tracking-tighter leading-[0.95] pl-[0.35em]">
                    <BoxedTitle size="md">{p.name.split(" ")[0]}</BoxedTitle>{" "}
                    {p.name.split(" ").slice(1).join(" ")}
                  </h2>
                  <p className="mt-6 text-[16px] leading-relaxed text-[#2a2a2a]">
                    {p.description}
                  </p>
                  <div className="mt-6 flex flex-wrap gap-2">
                    {p.tags.map((t) => (
                      <span
                        key={t}
                        className="font-mono-tiny px-3 py-1 border border-[#0a0a0a]"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="mt-10 flex flex-wrap gap-4">
                  <a
                    href={p.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="vbb-btn"
                    data-testid={`portfolio-visit-${p.slug}`}
                  >
                    Visit project &#8599;
                  </a>
                  <Link
                    to="/contact"
                    className="vbb-btn vbb-btn-ghost"
                    data-testid={`portfolio-collab-${p.slug}`}
                  >
                    Collaborate
                  </Link>
                </div>
              </div>
            </article>
          ))}

          {/* placeholder for upcoming */}
          <div
            className="vbb-border-t p-10 lg:p-14 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center"
            data-testid="portfolio-upcoming"
          >
            <div className="lg:col-span-7">
              <div className="font-mono-tiny text-[#6b6b6b]">
                Next — Quietly underway
              </div>
              <h3 className="font-display text-3xl sm:text-4xl mt-3 uppercase tracking-tight pl-[0.35em]">
                <BoxedTitle size="md">More</BoxedTitle> projects are in the
                box.
              </h3>
              <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-[#2a2a2a]">
                We announce work when it’s ready to be useful — not when it’s
                ready to be marketed. Drop us a note if you’re curious what
                we’re cooking.
              </p>
            </div>
            <div className="lg:col-span-5">
              <Link
                to="/contact"
                className="vbb-btn"
                data-testid="portfolio-contact-cta"
              >
                Ask us anything →
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
